import React, {
    Fragment,
    useEffect,
    useState,
    useCallback,
    useMemo,
} from 'react';
import { connect, useSelector } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Typography from '@material-ui/core/Typography';

import * as ApiTimeClock from '../../../api/ApiTimeClock';
import { getDepId } from '../../../utilities/Utils';
import { checkResStatusService } from '../../../utilities/ResServiceUtils';
import {
    getFirstDateOfCurentMount,
    getLastDateOfCurentMount,
    convertDateDisplay,
    formatDate,
    formatTime,
} from '../../../utilities/DatetimeUtils';
import { PERMISSION_ORG } from '../../../constants/APDConstants';
import * as AlertMSGConstants from '../../../constants/AlertMSGConstants';
import {
    getLutExclusiveOrgLeave,
    getCustomLutOrgLeave,
} from '../../../api/ApiOrgLeave';

import Loading from '../../../control/loading/Loading';
import UseLoadingState from '../../../control/loading/UseLoadingState';
import AlertMessage from '../../../control/alert/AlertMessage';
import UseAlertMessageState from '../../../control/alert/UseAlertMessageState';
import DataTable from '../../../control/table/DataTable';
import CustomButton from '../../../control/button/Button';

import GetAppIcon from '@material-ui/icons/GetApp';

import SearchForm from './SearchForm';
import { getFormValues } from 'redux-form';

const columns = [
    {
        title: 'ลำดับ',
        data: 'index',
        type: 'number',
        width: '3%',
    },
    {
        title: 'รหัสพนักงาน',
        data: 'empId',
        sort: true,
        width: '6%',
    },
    {
        title: 'ชื่อ-นามสกุล',
        data: 'fullName',
        sort: true,
        width: '15%',
        align: 'left',
    },
    {
        title: 'ฝ่าย',
        data: 'depShortName',
        sort: true,
        width: '8%',
        align: 'center',
    },
    {
        title: 'กอง',
        data: 'divName',
        sort: true,
        width: '12%',
        align: 'left',
    },
    {
        title: 'แผนก',
        data: 'secName',
        sort: true,
        width: '12%',
        align: 'left',
    },
    {
        title: 'วันที่',
        data: 'workingDate',
        type: 'date',
        sort: true,
        width: '8%',
    },
    {
        title: 'เวลาเข้างาน',
        data: 'clockInTimeDisplay',
        sort: true,
        width: '9%',
    },
    {
        title: 'เวลาออกงาน',
        data: 'clockOutTimeDisplay',
        sort: true,
        width: '9%',
    },
    {
        title: 'สถานที่บันทึกเวลาเข้างาน',
        data: 'clockInMachineCode',
        sort: true,
        width: '9%',
    },
    {
        title: 'สถานที่บันทึกเวลาออกงาน',
        data: 'clockOutMachineCode',
        sort: true,
        width: '9%',
    },
];

const detailsColumns = [
    {
        title: 'วันที่',
        data: 'workingDate',
        width: '25%',
    },
    {
        title: 'เวลา',
        data: 'workingTime',
        width: '25%',
    },
    {
        title: 'ประเภท',
        data: 'clockingType',
        width: '25%',
    },
    {
        title: 'สถานที่บันทึกเวลา',
        data: 'clockingMachineCode',
        width: '25%',
    },
];

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        height: '100%',
    },
    rootPaper: {
        minHeight: 'calc(100% - 48px)',
        margin: '24px',
        [theme.breakpoints.down('sm')]: {
            width: 'calc(98% - 48px)',
        },
        ...theme.paperPadding,
    },
    form: {
        marginTop: theme.spacing(2),
    },
    divider: {
        width: '100%',
        margin: '24px 0px',
    },
    result: {
        alignSelf: 'flex-end',
        textAlign: 'end',
    },
    buttonExportAll: {
        height: '40px',
        marginBottom: '5px',
        padding: '0px',
        marginLeft: '10px',
        paddingRight: '10px',
        paddingLeft: '10px',
        backgroundColor: '#016f01 !important',
        color: '#FFFFFF',
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalBody: {
        padding: theme.spacing(3),
    },
    modalLabel: {
        fontWeight: 'bold',
    },
    modalItemTable: {
        minWidth: 'auto',
    },
    btnCloseModal: {
        backgroundColor: `${theme.mainTheme.color6} !important`,
    },
}));

const defaultValues = {
    orgId: null,
    keyword: '',
    startDate: getFirstDateOfCurentMount(
        new Date(new Date().setMonth(new Date().getMonth())),
    ),
    endDate: getLastDateOfCurentMount(
        new Date(new Date().setMonth(new Date().getMonth())),
    ),
    dataTypeId: null,
};

const formId = 'TimeClockHistorySearchForm';

const History = ({ authenRdc }) => {
    const values = useSelector((state) => getFormValues(formId)(state));
    const classes = useStyles();
    const alertMessageState = UseAlertMessageState();
    const loadingState = UseLoadingState();

    const [lookups, setLookups] = useState({
        dataType: [
            {
                id: 1,
                label: 'ทั้งหมด',
            },
            {
                id: 2,
                label: 'ไม่พบข้อมูลเวลา',
            },
        ],
        organization: [],
    });
    const [tableConfig, setTableConfig] = useState({
        currentPage: 1,
        pageSize: 10,
        sortField: null,
        sortOrder: null,
        total: 0,
    });
    const [filters, setFilters] = useState({ ...defaultValues });
    const [results, setResults] = useState([]);
    const [itemDetails, setItemDetails] = useState();

    const depId = useMemo(() => getDepId(authenRdc.profile), [authenRdc]);

    const getLookups = useCallback(async () => {
        loadingState.showLoading();
        try {
            const response = await (authenRdc.profile.permissionOrgId ===
            PERMISSION_ORG.EXCLUSIVE_ORG
                ? getLutExclusiveOrgLeave(depId)
                : getCustomLutOrgLeave());
            loadingState.hideLoading();
            if (response.data) {
                setLookups({
                    ...lookups,
                    organization: response.data,
                });
            } else {
                alertMessageState.showAlert({
                    altMsg:
                        checkResStatusService(response) ||
                        AlertMSGConstants.SYSTEM_ERROR,
                });
            }
        } catch (error) {
            loadingState.hideLoading();
            alertMessageState.showAlert({
                altMsg: AlertMSGConstants.SYSTEM_ERROR,
            });
        }
    }, [authenRdc, loadingState, alertMessageState, depId, lookups]);

    const fetchData = useCallback(
        async (newTableConfig = {}, newFilters = {}) => {
            loadingState.showLoading();
            setFilters({
                ...filters,
                ...newFilters,
            });
            const permissionOrgId = authenRdc.profile.permissionOrgId;
            const parameters = {
                ...tableConfig,
                ...newTableConfig,
                ...filters,
                ...newFilters,
                permissionOrgId: permissionOrgId,
                depId: [
                    PERMISSION_ORG.PERSONAL_ORG,
                    PERMISSION_ORG.EXCLUSIVE_ORG,
                ].includes(permissionOrgId)
                    ? authenRdc.profile.depId
                    : null,
            };
            delete parameters.total;
            try {
                const response =
                    await ApiTimeClock.fetchAttendanceHistory(parameters);
                // const response = {
                //   items: [],
                //   total: 75,
                // }
                loadingState.hideLoading();
                if (response.data.items) {
                    const startIndex =
                        parameters.pageSize * (parameters.currentPage - 1) + 1;
                    // for (let index = 0; index < parameters.pageSize; index++) {
                    //   const _index = startIndex + index
                    //   response.items.push({
                    //     "empId": `Emp. ${_index}`,
                    //     "fullName": `First Last ${_index}`,
                    //     "depName": `Dept. ${_index}`,
                    //     "divName": `Div. ${_index}`,
                    //     "secName": `Sec. ${_index}`,
                    //     "workingDate": "2025-03-25T08:21:57.071Z",
                    //     "clockInTime": "2025-03-25T00:21:57.071Z",
                    //     "clockOutTime": "2025-03-25T18:21:57.071Z",
                    //     "clockInMachineCode": `MC I ${_index}`,
                    //     "clockOutMachineCode": `MC O ${_index}`
                    //   })
                    // }
                    setResults(
                        response.data.items.map((item, index) => ({
                            ...item,
                            detail: true,
                            index: startIndex + index,
                            workingDate: item.workingDate
                                ? convertDateDisplay(
                                      formatDate(new Date(item.workingDate)),
                                  )
                                : '-',
                            actualDate: item.workingDate,
                            clockInTime: formatTime(item.clockInTime),
                            clockOutTime: formatTime(item.clockOutTime),
                        })),
                    );
                    setTableConfig((prev) => ({
                        ...prev,
                        ...newTableConfig,
                        total: response.data.total,
                    }));
                } else {
                    alertMessageState.showAlert({
                        altMsg:
                            checkResStatusService(response) ||
                            AlertMSGConstants.SYSTEM_ERROR,
                    });
                }
            } catch (error) {
                loadingState.hideLoading();
                alertMessageState.showAlert({
                    altMsg: AlertMSGConstants.SYSTEM_ERROR,
                });
            }
        },
        [
            alertMessageState,
            authenRdc.profile.depId,
            authenRdc.profile.permissionOrgId,
            filters,
            loadingState,
            tableConfig,
        ],
    );

    const exportData = useCallback(
        async (newTableConfig = {}, newFilters = {}) => {
            loadingState.showLoading();
            setFilters({
                ...filters,
                ...newFilters,
            });
            const permissionOrgId = authenRdc.profile.permissionOrgId;
            const parameters = {
                ...tableConfig,
                ...newTableConfig,
                ...filters,
                ...newFilters,
                permissionOrgId: permissionOrgId,
                depId: [
                    PERMISSION_ORG.PERSONAL_ORG,
                    PERMISSION_ORG.EXCLUSIVE_ORG,
                ].includes(permissionOrgId)
                    ? authenRdc.profile.depId
                    : null,
            };
            delete parameters.total;
            delete parameters.pageSize;
            delete parameters.currentPage;
            try {
                const response =
                    await ApiTimeClock.exportAttendanceHistory(parameters);
                loadingState.hideLoading();
                if (response) {
                    const url = window.URL.createObjectURL(response);
                    const link = document.createElement('a');
                    link.href = url;

                    link.setAttribute(
                        'download',
                        'ประวัติการบันทึกเวลาเข้าออกงาน.xlsx',
                    );
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                } else {
                    alertMessageState.showAlert({
                        altMsg:
                            // checkResStatusService(response) ||
                            AlertMSGConstants.SYSTEM_ERROR,
                    });
                }
            } catch (error) {
                loadingState.hideLoading();
                alertMessageState.showAlert({
                    altMsg: AlertMSGConstants.SYSTEM_ERROR,
                });
            }
        },
        [
            alertMessageState,
            authenRdc.profile.depId,
            authenRdc.profile.permissionOrgId,
            filters,
            loadingState,
            tableConfig,
        ],
    );

    const fetchItemDetails = useCallback(
        async (item) => {
            loadingState.showLoading();
            const parameters = {
                uuid: item.uuid,
                workingDate: item.actualDate,
            };
            delete parameters.total;
            try {
                const response =
                    await ApiTimeClock.fetchAttendanceHistoryDetails(
                        parameters,
                    );
                loadingState.hideLoading();
                if (response.data.items) {
                    setItemDetails({
                        ...response.data,
                        items: response.data.items.map((item) => ({
                            ...item,
                            workingDate: item.workingDate
                                ? convertDateDisplay(
                                      formatDate(new Date(item.workingDate)),
                                  )
                                : '-',
                            workingTime: item.attendanceTimeDisplay
                                ? item.attendanceTimeDisplay
                                : '-',
                            clockingType: item.workingTypeName
                                ? item.workingTypeName
                                : '-',
                            clockingMachineCode: item.machineCode
                                ? item.machineCode
                                : '-',
                            depShortName: item.depShortName
                                ? item.depShortName
                                : '-',
                        })),
                    });
                } else {
                    alertMessageState.showAlert({
                        altMsg:
                            checkResStatusService(response) ||
                            AlertMSGConstants.SYSTEM_ERROR,
                    });
                }
            } catch (error) {
                loadingState.hideLoading();
                alertMessageState.showAlert({
                    altMsg: AlertMSGConstants.SYSTEM_ERROR,
                });
            }
        },
        [alertMessageState, loadingState],
    );

    useEffect(() => {
        getLookups();
    }, []);

    const handleClickExport = useCallback(() => {
        exportData({ ...values });
    }, [exportData, values]);

    const handleSubmitSearchForm = useCallback(
        (values) => {
            fetchData({ currentPage: 1 }, { ...values });
        },
        [fetchData],
    );

    const handleSortChange = useCallback(
        (sortField, sortOrder) => {
            fetchData({
                currentPage: 1,
                sortField,
                sortOrder,
            });
        },
        [fetchData],
    );

    const handlePageChange = useCallback(
        (currentPage) => {
            fetchData({ currentPage });
        },
        [fetchData],
    );

    const handleRowClick = useCallback(
        (item) => {
            fetchItemDetails(item);
        },
        [fetchItemDetails],
    );

    const handleClickCloseModal = useCallback(() => {
        setItemDetails();
    }, []);

    return (
        <Fragment>
            <Scrollbars universal={true}>
                <Paper className={classes.rootPaper}>
                    <Grid container justify="center">
                        <Grid item xs={12} className={classes.form}>
                            <SearchForm
                                defaultValues={defaultValues}
                                lookups={lookups}
                                showOrganization={
                                    authenRdc.profile.permissionOrgId !==
                                    PERMISSION_ORG.PERSONAL_ORG
                                }
                                onSubmit={handleSubmitSearchForm}
                            />
                        </Grid>
                        <Grid item xs={12} className={classes.divider}>
                            <Divider />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h5" component="span">
                                ประวัติการบันทึกเวลา
                            </Typography>
                            {results.length > 0 && (
                                <Button
                                    variant="contained"
                                    className={classes.buttonExportAll}
                                    startIcon={<GetAppIcon />}
                                    onClick={handleClickExport}
                                >
                                    ออกรายงาน EXCEL
                                </Button>
                            )}
                        </Grid>
                        <Grid item xs={12} md={6} className={classes.result}>
                            พบผลลัพธ์ทั้งหมด {tableConfig.total} รายการ
                        </Grid>
                        <Grid item xs={12}>
                            <DataTable
                                column={columns}
                                rowPerPage={tableConfig.pageSize}
                                notSort={true}
                                page={tableConfig.currentPage}
                                data={results}
                                total={tableConfig.total}
                                sortColumn={tableConfig.sortField}
                                sortType={tableConfig.sortOrder}
                                handleSortExternal={handleSortChange}
                                handlePageChange={handlePageChange}
                                handleRowClick={handleRowClick}
                                minWidth="2000px"
                            />
                        </Grid>
                    </Grid>
                </Paper>
            </Scrollbars>
            <Modal className={classes.modal} open={!!itemDetails}>
                {itemDetails && (
                    <Paper className={classes.paper}>
                        <Grid
                            container
                            justify="center"
                            style={{ overflow: 'hidden' }}
                        >
                            <Grid
                                container
                                className={classes.modalBody}
                                spacing={2}
                            >
                                <Grid item xs={12}>
                                    <Typography variant="h5">
                                        ประวัติการบันทึกเวลา
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2">
                                        <label className={classes.modalLabel}>
                                            รหัสพนักงาน:
                                        </label>
                                        {` ${itemDetails.empId || ''}`}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2">
                                        <label className={classes.modalLabel}>
                                            ชื่อ-นามสกุล:
                                        </label>
                                        {` ${itemDetails.fullName || ''}`}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <DataTable
                                        classes={{
                                            table: classes.modalItemTable,
                                        }}
                                        column={detailsColumns}
                                        notSort={true}
                                        hidePagination={true}
                                        data={itemDetails.items}
                                    />
                                </Grid>
                                <Grid container spacing={2} justify="center">
                                    <Grid item>
                                        <CustomButton
                                            label="ปิด"
                                            className={classes.btnCloseModal}
                                            onClick={handleClickCloseModal}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                )}
            </Modal>
            <AlertMessage {...alertMessageState.altProps} />
            <Loading isShowLoading={loadingState.isShowLoading} />
        </Fragment>
    );
};

export default connect((state) => ({
    authenRdc: state.authen,
}))(History);
